module.exports = __webpack_public_path__ + "img/import-schedule.517e005d.svg";